import { UserInterface } from 'app/core/user/models';

export interface ReviewInterface {
  esppId?: number;
  id?: number;
  date?: string;
  text?: string;
  author?: UserInterface;
}

export class Review implements ReviewInterface {
  public esppId?: number;
  public id?: number;
  public date?: string;
  public text?: string;
  public author?: UserInterface;

  constructor({
    esppId = undefined,
    id = undefined,
    date = undefined,
    text = undefined,
    author = undefined,
    }: ReviewInterface) {
    this.esppId = esppId;
    this.id = id;
    this.date = date;
    this.text = text;
    this.author = author;
  }
}
